import { DateTime } from 'luxon';

import type { FilterTimeType } from 'types/Filter';

export const convertToTimeFromPeriod = (
	timeType: FilterTimeType
): { startTime: string; endTime: string } => {
	const date = DateTime.now();

	switch (timeType) {
		case 'daily':
			return { startTime: date.startOf('day').toISO(), endTime: date.endOf('day').toISO() };
		case 'weekly':
			return {
				startTime: date.startOf('week', { useLocaleWeeks: true }).toISO(),
				endTime: date.endOf('week', { useLocaleWeeks: true }).toISO(),
			};
		case 'monthly':
			return {
				startTime: date.startOf('month').toISO(),
				endTime: date.endOf('month').toISO(),
			};
		case 'custom':
			return { startTime: date.startOf('day').toISO(), endTime: date.endOf('day').toISO() };
		default:
			return { startTime: date.startOf('day').toISO(), endTime: date.endOf('day').toISO() };
	}
};
